const BaseComponent = require('base/base-component');

class timeChain extends BaseComponent {
  constructor () {
    super({
      events: {
        // 'click .tl-btn': 'handleClick'
      }
    });
  }
  init () {
    this.data = JSON.parse(this.$el.find('[name=relevant-articles]').val());
    this.renderTimeBase(this.data);
  }
  // 渲染时间轴
  renderTimeBase (datasource) {
    const data = datasource.filter(item => item.typeName !== '项目信息');
    let htmlStr = '';
    let len = data.length;
    let triggerTimes = 0;
    this.$chainBox = this.$el;
    this.$chainBtn = this.$chainBox.find('.tl-btn');
    this.$chainContainer = this.$chainBox.find('.sx-container');
    for (let i = 0; i < len; i++) {
      if (data[i].isExist == 1) {
        if (data[i].isCurrent == 1) {
          if (i > 9) {
            triggerTimes = Math.floor((i - 1) / 9);
          }
          htmlStr +=
            `<div class="sx-time-box">
            <div class="sx-time-line-box">
              <div class="sx-tl-horizontal"></div>
              <div class="sx-icon sx-big-icon">
                <i class="icon iconfont icon-notify-success" ></i>
              </div>
            </div>
            <div class="sx-time-content-box">
              <span class="sx-triangle"></span>
              <a href='${data[i].url}'>
                <span class="sx-time-content-title">${data[i].typeName}</span>
                <br />
                <span class="sx-time-content-time">${data[i].publishDate ? data[i].publishDate : ''}</span>
              </a>
            </div>
          </div>`;
        } else {
          htmlStr += `<div class="sx-time-isExist-box">
          <div class="sx-time-line-box">
            <div class="sx-tl-horizontal"></div>
            <div class="sx-icon">
              <i class="icon iconfont icon-quan"></i>
            </div>
          </div>
          <div class="sx-time-content-box">
            <a href='${data[i].url}'>
              <span class="sx-time-content-title">${data[i].typeName}</span>
              <br />
              <span class="sx-time-content-time">${data[i].publishDate ? data[i].publishDate : ''}</span>
            </a>
          </div>
        </div>`;
        }
      } else {
        htmlStr += `<div class="sx-time-noExist-box">
        <div class="sx-time-line-box">
          <div class="sx-tl-horizontal"></div>
          <div class="sx-icon">
            <i class="icon iconfont icon-quan"></i>
          </div>
        </div>
        <div class="sx-time-content-box">
          <span class="sx-time-content-title">${data[i].typeName}</span>
          <br />
          <span class="sx-time-content-time"></span>
        </div>
      </div>`;
      }
    }
    // console.log(htmlStr);
    this.$chainContainer.html(htmlStr);
    // this.$chainBox.addClass('show');
    // if (!this.countNum) {
    //   this.countNum = 0;
    // }
    // this.limit = Math.floor((len - 1) / 9);
    // if (this.limit > 0) {
    //   if (this.countNum < this.limit) {
    //     this.$chainBtn.show().eq(1).addClass('canClick');
    //     // 时间轴移动到当前
    //     if (triggerTimes !== 0) {
    //       while (triggerTimes > 0) {
    //         this.$el.find('.tl-btn[data-type="right"]').trigger('click');
    //         triggerTimes--;
    //       }
    //     }
    //   }
    // } else if (len !== 9) { // 少于九个居中显示
    //   const leftValue = (890 - len * 95) / 2 - 45;
    //   this.$chainContainer.css({
    //     left: leftValue
    //   });
    // }
  }

  handleClick (e) {
    let $target = $(e.target || e.srcElement);
    if (!$target.hasClass('canClick')) {
      return;
    }
    let leftVal = null;
    if ($target.data('type') === 'left') {
      if (this.countNum <= 1) {
        $target.removeClass('canClick');
      }
      if (this.countNum == this.limit) {
        this.$chainBtn.eq(1).addClass('canClick');
      }
      this.countNum--;
      // console.log(this.countNum);
      leftVal = -890 * this.countNum + 'px';
    } else {
      if (this.countNum >= (this.limit - 1)) {
        $target.removeClass('canClick');
      }
      if (this.countNum == 0) {
        this.$chainBtn.eq(0).addClass('canClick');
      }
      this.countNum++;
      leftVal = -890 * this.countNum + 'px';
    }
    $('.tl-container').animate({
      left: leftVal
    }, 'slow');
  }
}
module.exports = timeChain;
